import React from 'react';
import { Link } from 'react-router-dom';

// Import posts
//import { createTitleComponent } from '../../helpers/createTitleComponent';
import { postsList } from './PostsList';

export default function BlogMenu({ numberOfPosts = postsList.length, level }) {
  const displayPosts = postsList.slice(0, numberOfPosts); // Slice the array based on the number of posts

  return (
    <div className="bg-white py-6 sm:py-10">
      <div className="w-11/12 mx-auto">
        <div className="bg-white rounded-2xl shadow-xl ring-1 ring-slate-200/80 p-6 sm:p-8">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">
                Blog
              </h2>
              <p className="mt-1 text-sm text-slate-600">
                Data notes, course history, and how we rank.
              </p>
            </div>
            <Link
              to="/blog"
              className="text-xs font-semibold text-indigo-700 hover:text-indigo-900 hover:underline"
            >
              View all →
            </Link>
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {displayPosts.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.blogurl}`}
                className="group rounded-2xl border border-slate-200 hover:border-slate-400 hover:bg-slate-50 p-5 transition-colors"
              >
                <div className="flex items-center justify-between gap-3">
                  <time
                    dateTime={post.datetime}
                    className="text-xxs font-mono text-slate-500"
                  >
                    {post.date}
                  </time>
                  <span className="text-xxs font-mono text-slate-500 truncate">
                    {post.author?.name || 'GolfLists'}
                  </span>
                </div>
                <div className="mt-3 text-sm font-extrabold text-slate-900 group-hover:underline">
                  {post.title}
                </div>
                <div className="mt-3 flex flex-wrap gap-2">
                  <span className="text-xxs px-2 py-1 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-100">
                    GolfLists
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
